import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { stopPropagation } from '../../../../../helpers/common';
import { propArrayShape, propBool, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../helpers/recompose';
import DirectoryIcon from '../../../../Icon/Svg/DirectoryIcon';
import ModalHoc from '../../../../Ui/Modal/ModalHoc';
import ActionSaveBody from './ActionSaveBody';
const ActionSaveInner = (props) => {
    const { className, folders, hideModal, loading, modalState, onClickAdd, onClickSave, showBg, } = props;
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: clsx('action_save_modal animated-opacity', modalState, className), onClick: stopPropagation, role: 'presentation' }, { children: [_jsxs("div", Object.assign({ className: 'action_save_modal_header' }, { children: [_jsx(DirectoryIcon, {}), _jsx("span", Object.assign({ className: 'action_save_modal_header_text' }, { children: "\u4FDD\u5B58\u3059\u308B\u30D5\u30A9\u30EB\u30C0\u3092\u9078\u3076" }))] })), _jsx(ActionSaveBody, { className: 'action_save_modal_body', folders: folders, loading: loading, onClickSave: onClickSave }), _jsx("div", Object.assign({ className: 'action_save_modal_footer' }, { children: _jsxs("button", Object.assign({ className: 'add_button', disabled: loading, onClick: onClickAdd, type: 'button' }, { children: [_jsx("i", { className: 'css_plus_icon' }), _jsx("span", Object.assign({ className: 'add_button_text' }, { children: "\u65B0\u898F\u30D5\u30A9\u30EB\u30C0\u3092\u4F5C\u6210" }))] })) }))] })), showBg && (_jsx("div", { className: clsx('action_modal_bg bg-modal animated-opacity', modalState), onClick: hideModal, role: 'presentation' }))] }));
};
ActionSaveInner.propTypes = {
    className: propStr().isRequired,
    folders: propArrayShape().isRequired,
    hideModal: propFunc().isRequired,
    loading: propBool().isRequired,
    modalState: propStr().isRequired,
    onClickAdd: propFunc().isRequired,
    onClickSave: propFunc().isRequired,
    showBg: propBool().isRequired,
};
const enhance = compose(ModalHoc);
const ActionSave = enhance(ActionSaveInner);
ActionSave.propTypes = {
    className: propStr().isRequired,
    folders: propArrayShape().isRequired,
    hideModal: propFunc().isRequired,
    isShow: propBool().isRequired,
    onClickAdd: propFunc().isRequired,
    onClickSave: propFunc().isRequired,
    showBg: propBool().isRequired,
};
export default ActionSave;
